var timeZoneJSON = require("json!../static/time-zones.json");

const $inject = [];
const timeZoneService = function () {
  let service = {};

  service.get = function get() {
    var zones = _.values(timeZoneJSON.zones);

    return _.map(zones, zone => {
      return zone.name;
    });
  };

  return service;
};

timeZoneService.$inject = $inject;

export default timeZoneService;


// WEBPACK FOOTER //
// ./src/services/timeZoneService.js